/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(t,s){this.text=t,this.score=s}}export{t as default};
